<aside
  class="fixed transition-width duration-200 ease-in-out h-screen inset-y-0 ease-nav-brand z-50"
  [class.w-20]="sidebarService.$collapsed | async"
  [class.w-64]="!(sidebarService.$collapsed | async)"
  (mouseenter)="onMouseEnter()"
  (mouseleave)="onMouseLeave()">
  <div
    class="sidebar-inner h-full flex flex-col items-start gap-10 py-12 px-7 shadow-xl shrink-0 dark:border-r dark:border-night-700">
    <button
      (click)="toggleSidebar()"
      class="toogle absolute rounded-full w-7 h-7 flex items-center justify-center shadow-md"
      [class.invisible]="(sidebarService.$collapsed | async) && (sidebarService.$pinnedCollapsed | async)">
      <ng-container *ngIf="sidebarService.$pinnedCollapsed | async; else expanded">
        <app-icon-wrapper [icon]="'chevron-double'" [color]="'#fff'" [size]="'small-medium'" class="rotate-180" />
      </ng-container>
      <ng-template #expanded>
        <app-icon-wrapper [icon]="'chevron-double'" [color]="'#fff'" [size]="'small-medium'" />
      </ng-template>
    </button>
    <ng-content></ng-content>
  </div>
</aside>
